import { ReportingStatus } from 'api';

export const ACTIVE_STATUSES: ReportingStatus[] = ['live'];
export const IN_PROGRESS_STATUSES: ReportingStatus[] = ['setupInProgress'];
export const PAUSED_STATUSES: ReportingStatus[] = [
  'paused',
  'pausedClientRequest',
  'inactive',
];
